import PropTypes from 'prop-types';

export default PropTypes.shape({
  control: PropTypes.shape({}).isRequired,
  formState: PropTypes.shape({ errors: PropTypes.shape({}) }).isRequired,
  register: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  watch: PropTypes.func.isRequired
});
